import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { setError } from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { mapToObjectDDL } from "../../../../common/mapper";
import ReportRO from "./components/reportRO";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";

class DashboardMonitoringROKabengKacab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCabang: [],
      kodeCabang: null,
      search: {},
      loading: false,
      doSearch: false,
      isAllSelected: true,
      isSpecificSelected: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  fetchDataCabang = async () => {
    this.handleTriggerLoading();

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Dashboard CRM Kabeng Kacab - Prospek Daily",
    });
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState((prev) => ({
          ...prev,
          dataCabang: filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang),
          ),
        }));
      }
    }
  };

  handleSelectCabang = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isSpecificSelected: false,
        kodeCabang: [],
      }));
    }

    if (type === "SPECIFIC") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAllSelected: false,
        kodeCabang: [],
      }));
    }
  };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({ ...prevValue, kodeCabang: value }));
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  render() {
    const { dataCabang, kodeCabang, isAllSelected, isSpecificSelected } =
      this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleCheckBox
              id="reportAllCabang"
              key="reportAllCabang"
              name="reportAllCabang"
              label="ALL CABANG"
              checked={isAllSelected}
              onChange={(e) => this.handleSelectCabang(e, "ALL")}
            />
            <SimpleCheckBox
              id="reportSpecificCabang"
              key="reportSpecificCabang"
              name="reportSpecificCabang"
              label="SPESIFIK CABANG"
              checked={isSpecificSelected}
              onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
            />
            <SimpleDDL
              id="select_options_kode_cabang"
              box="multiselect"
              name="kodeCabang"
              containerclassname="width width-500px margin-top-15px"
              placeholder="Nama Cabang"
              readOnly={!isSpecificSelected}
              options={dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Statistik Repeat Order</Tab>
              <Tab>Laporan Statistik RO H23 Per Cabang YTD</Tab>
            </TabList>
            <TabPanel key="statistik_prospek_today">
              <ReportRO
                {...this.props}
                tab="ro"
                selectedCabang={kodeCabang}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel key="appointment_fu_today">
              <ReportRO
                {...this.props}
                tab="ytd"
                selectedCabang={kodeCabang}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
          </Tabs>
        </Container>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setError: (payload) => dispatch(setError(payload)),
});

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardMonitoringROKabengKacab);
